export class UpdateSwipeabilityEvent extends Event {
    sceneHovering: boolean;

    constructor() {
        super("swipeabilityUpdate");

        this.sceneHovering = false;
    }

}

declare global {
    interface WindowEventMap {
        swipeabilityUpdate: UpdateSwipeabilityEvent;
    }
}